import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Reporting } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ReportingModule extends VuexModule {
    @Action
    [Reporting.findPageReporting](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/reporting/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Reporting.saveReporting](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/reporting/update`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Reporting.deleteReporting](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/reporting/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}